function Users() {
    return (
      <>
        <div className="font-bold text-lg mb-16">Users</div>
      </>
    );
  }
  
  export default Users;